import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Analytics } from "@vercel/analytics/react";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import HomePage from "./pages/HomePage";
import ProjectsPage from "./pages/ProjectsPage";
import ArticlesPage from "./pages/ArticlesPage";
import ArticleDetailPage from "./pages/ArticleDetailPage";
import AroundTheWorldPage from "./pages/AroundTheWorldPage";
import ProjectDetailPage from "./pages/ProjectDetailPage";

function App() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col bg-terminal">
      <Navbar />
      <main className="flex-1">
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<HomePage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/projects/:id" element={<ProjectDetailPage />} />
            <Route path="/articles" element={<ArticlesPage />} />
            <Route path="/articles/:slug" element={<ArticleDetailPage />} />
            <Route path="/around-the-world" element={<AroundTheWorldPage />} />
          </Routes>
        </AnimatePresence>
      </main>
      <Footer />
      <Analytics />
    </div>
  );
}

export default App;
